import api from "./api";

export interface PortfolioItemApi {
  // technology + company are the active simplified fields the dashboard
  // edits. Everything below them is legacy/unused-but-still-served.
  id: string;
  slug: string;
  title: string;
  description: string | null;
  image_url: string | null;
  technology: string | null;
  company: string | null;
  // Legacy / pass-through
  subtitle: string | null;
  summary: string | null;
  project_url: string | null;
  client: string | null;
  tag: string | null;
  keywords: string[];
  status: string;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export interface PortfolioListApi {
  total: number;
  items: PortfolioItemApi[];
}

export interface PortfolioTagRow {
  name: string;
  count: number;
}

export const portfolioService = {
  list: async (params?: { tag?: string }): Promise<PortfolioListApi> => {
    const { data } = await api.get<PortfolioListApi>("/portfolio", { params });
    return data;
  },

  listTags: async (): Promise<PortfolioTagRow[]> => {
    const { data } = await api.get<{ tags: PortfolioTagRow[] }>("/portfolio/tags");
    return data.tags;
  },

  getBySlug: async (slug: string): Promise<PortfolioItemApi> => {
    const { data } = await api.get<PortfolioItemApi>(`/portfolio/${slug}`);
    return data;
  },
};
